/* eslint-disable jsx-a11y/anchor-is-valid */
import classNames from 'classnames';
import { RefObject } from 'react';
import styles from './DownloadCSVButton.module.css';
import { IconDownload } from './QuirkIcons';

/**
 * Consistently format and escape a CSV value
 * @param {string | null | undefined} value The value to format
 * @returns {string} The escaped value
 */
const formatCSVValue = (value: string | null | undefined) => {
	if (value === null || value === undefined) {
		return '""';
	}
	const needsQuotes = value.includes(',') || value.includes('\n') || value.includes('"');
	if (needsQuotes) {
		// Replace any quote characters in the value with double-quotes (standard CSV escaping)
		return `"${value.replace(/"/g, '""')}"`;
	} else {
		return value;
	}
};
interface DownloadCSVButtonProps {
	style: React.CSSProperties;
	className?: string;
	label: string;
	filename: string;
	tableRef: RefObject<HTMLTableElement>;
}
export const DownloadCSVButton: React.FC<DownloadCSVButtonProps> = ({
	style,
	className,
	label,
	filename,
	tableRef
}) => {
	const handleClick = () => {
		const tableToCSV = (table: HTMLTableElement) => {
			const header = [];
			const csvRows = [];

			// Get header
			for (const th of Array.from(table.querySelectorAll('th'))) {
				header.push(th.textContent);
			}
			csvRows.push(header.join(','));

			// Get rows
			for (const row of Array.from(table.querySelectorAll('tr'))) {
				const rowData = [];
				for (const cell of Array.from(row.querySelectorAll('td'))) {
					rowData.push(cell.textContent);
				}

				if (rowData.length > 0) {
					csvRows.push(rowData.map(formatCSVValue).join(','));
				}
			}

			return csvRows.join('\n');
		};

		if (!tableRef.current) return '#';
		const csvData = tableToCSV(tableRef.current);

		const csvFile = new Blob([csvData], { type: 'text/csv' });
		const downloadLink = URL.createObjectURL(csvFile);

		return downloadLink;
	};

	return (
		<div className={styles.buttonContainer}>
			<div>
				<IconDownload />
			</div>
			<div>
				<a
					className={classNames(className)}
					style={style}
					onClick={e => {
						(e.target as HTMLAnchorElement).href = handleClick();
					}}
					download={`${filename}.csv`}
				>
					{label}
				</a>
			</div>
		</div>
	);
};
